module.exports = __webpack_public_path__ + "static/media/compass.cfa0d4d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/direction-overlay/compass.svg
// module id = 441
// module chunks = 0